import { Visibility } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, Fab, IconButton, Portal, useTheme } from "@mui/material";
import { FC, PropsWithChildren, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

type SummaryFabProps = {
  marginBottom?: number;
}

const SummaryFab: FC<PropsWithChildren<SummaryFabProps>> = ({marginBottom=0, children}): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const theme = useTheme();

  return (
    <Portal>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <DialogTitle>
          Resumo

          <IconButton
            aria-label="close"
            onClick={() => setIsOpen(false)}
            sx={(_) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {children}
        </DialogContent>
      </Dialog>
      <Fab
        color="primary"
        variant="extended"
        onClick={() => {
          setIsOpen(true);
        }}
        sx={{
          margin: 0,
          marginBottom: marginBottom,
          top: 'auto',
          right: 20,
          bottom: 20,
          left: 'auto',
          position: 'fixed',
          borderRadius: '5px',
        }}
      >
        <Visibility sx={{marginRight: "0.25rem"}} /> Ver Resumo
      </Fab>
    </Portal>
  )
}

export default SummaryFab;
